import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Card, CardContent, Badge } from '@/shared/ui'
import { useRewardsHomeEnabled } from '../hooks/useRewardsHomeEnabled'

export default function RewardsHomeSection() {
  const enabled = useRewardsHomeEnabled()
  if (enabled !== true) return null

  return (
    <section className="mx-auto w-full max-w-[1200px] px-6 py-10">
      <Card className="border-border/60 bg-muted/20">
        <CardContent className="grid gap-6 py-8 md:grid-cols-2">
          <div className="space-y-3">
            <div className="flex items-center gap-2">
              <Badge variant="soft" color="primary">
                Rewards
              </Badge>
              <Badge variant="soft" color="warning">
                Trial 30 dias (condicional)
              </Badge>
            </div>
            <h2 className="text-2xl font-semibold">Ganhe desconto na assinatura com performance real</h2>
            <p className="text-sm text-foreground/70">
              Vincule sua conta na corretora ao programa do Cripto Alert e transforme seu volume de negociação em desconto por ciclo — sem carry-over e com margem sempre positiva.
            </p>
            <div className="text-xs text-foreground/60">
              Regras: desconto progressivo por ciclo com base em dados confirmados pela corretora. (Configuração ajustável pelo MASTER.)
            </div>
          </div>

          <div className="flex flex-col items-start justify-center gap-3 md:items-end">
            <Button asChild>
              <Link to="/checkout?rewards_trial=1">Quero tentar o Trial Rewards</Link>
            </Button>
            <div className="text-xs text-foreground/60 md:text-right">
              Sujeito à vinculação + volume mínimo em 7 dias.
            </div>
          </div>
        </CardContent>
      </Card>
    </section>
  )
}
